import { Injectable } from '@angular/core';
import { Admin } from '../models/admin';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private adminCollection: AngularFirestoreCollection<Admin>;

  constructor(private db: AngularFirestore) {
    this.adminCollection = this.db.collection<Admin>('admin');
  }

  /**
  * GET ALL JUGADORES POR DE UNA ID DE QUINIELA
  */
  getCredential(email: string, pin: number): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('admin', (ref) =>
      ref.where('email', '==', email)
    );
    return query.snapshotChanges()
  }

  /**
   * GET ALL ADMINS
   */
  getAllAdmins(): Observable<DocumentChangeAction<Admin>[]> {
    return this.adminCollection.snapshotChanges();
  }

  getAdmin(email: string): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('admin', (ref) =>
      ref.where('email', '==', email)
    );
    return query.snapshotChanges()
  }

}
